import React from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';

export default function AttachmentsSection({ ctx, res }) {
  const attachments = Array.isArray(ctx?.state?.attachments) ? ctx.state.attachments : [];
  const removalIds = new Set(Array.isArray(ctx?.state?.attachmentsRemoveIds) ? ctx.state.attachmentsRemoveIds : []);
  const readOnly = !ctx.state.editForm;

  const isMarkedForRemoval = (item) => Number.isInteger(item?.id) && removalIds.has(Number(item.id));
  const displayName = (item) => item.fileName || item.file_name || '';
  const displaySize = (item) => ctx.attachmentsFormatSize(item.size || item.size_bytes);

  const getExt = (item) => {
    const byProp = (item?.file_ext || '').toLowerCase();
    if (byProp) return byProp;
    const name = displayName(item);
    const i = name.lastIndexOf('.');
    return i >= 0 ? name.slice(i + 1).toLowerCase() : '';
  };

  const isDownloadOnly = (item) => {
    const ext = getExt(item);
    return ext === 'kml' || ext === 'kmz';
  };

  const isNonDeletable = (item) => !!(item?.is_report || item?.readonly);

  const blockAndAlert = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof ctx?.alertReadOnly === 'function') ctx.alertReadOnly();
  };

  return (
    <div style={{ display: ctx.state.tabValue === 4 ? 'flex' : 'none', flexDirection: 'column', marginTop: 16 }}>
      <h2 style={{ margin: 0 }}>{res.ANEXOS}</h2>

      <div style={{ margin: '8px 0 16px' }}>
        <input
          ref={ctx.attachmentInputRef}
          type="file"
          multiple
          onChange={ctx.attachmentsOnInputChange}
          style={{ display: 'none' }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => { if (!readOnly) ctx.attachmentsOpenPicker(); }}
          onMouseDown={readOnly ? blockAndAlert : undefined}
          onKeyDown={(e) => {
            if (readOnly && (e.key === 'Enter' || e.key === ' ')) blockAndAlert(e);
          }}
          tabIndex={readOnly ? -1 : 0}
          aria-readonly={readOnly}
        >
          {res.ADICIONAR_ARQUIVO}
        </Button>
      </div>

      <Paper style={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{res.NOME_ARQUIVO}</TableCell>
              <TableCell>{res.TAMANHO}</TableCell>
              <TableCell align="center">{res.ACOES}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attachments.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center" style={{ color: '#777' }}>
                  {res.SEM_ANEXOS}
                </TableCell>
              </TableRow>
            ) : (
              attachments.map((item, index) => {
                const marked = isMarkedForRemoval(item);
                const downloadOnly = isDownloadOnly(item);
                const nonDeletable = isNonDeletable(item);

                return (
                  <TableRow
                    key={item.id || `row_${index}`}
                    style={marked ? { opacity: 0.6, textDecoration: 'line-through' } : undefined}
                  >
                    <TableCell>{displayName(item)}</TableCell>
                    <TableCell>{displaySize(item)}</TableCell>
                    <TableCell align="center">
                      <Tooltip title={downloadOnly ? (res.BAIXAR) : (res.VISUALIZAR)}>
                        <IconButton size="small" onClick={() => ctx.attachmentsViewItem(item)}>
                          {downloadOnly ? <GetAppIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </Tooltip>

                      {!nonDeletable && !readOnly && (
                        <Tooltip title={res?.EXCLUIR}>
                          <IconButton
                            size="small"
                            onClick={() => ctx.attachmentsRemoveItem(index)}
                            tabIndex={0}
                            aria-readonly={false}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}